import { render, staticRenderFns } from "./ShareProjectDialog.vue?vue&type=template&id=3902697d&scoped=true"
import script from "./ShareProjectDialog.vue?vue&type=script&lang=js"
export * from "./ShareProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902697d",
  null
  
)

export default component.exports